<template>
  <Card>
    <span slot="title">患者档案详情</span>
    <el-button slot="btn" class="fr" @click="$router.go(-1)">返回列表</el-button>
    <div slot="content" class="patientwrap">
      <!-- 患者统计信息 -->
      <div class="statisticsMsg" v-loading="loading">
        <div class="title p10">概要信息</div>
        <div class="content p10">
          <div class="line">
            <div class="display-f align-i-c">
              姓名：
              <span style="margin-right: 5px;">{{orderPatientInfo.patientName}}</span>
              <img v-if="orderPatientInfo.sysMember && orderPatientInfo.sysMember.openId" :src="imgArr.weixin"
                width="18" height="18">
            </div>
            <div>性别：{{ orderPatientInfo.sex == '0' ? '男' : '女' }}</div>
            <div>年龄：{{ orderPatientInfo.year }}岁<span
                v-show="orderPatientInfo.year < 10 && orderPatientInfo.month > 0">{{orderPatientInfo.month}}月</span>
            </div>
            <div>电话号码：{{ orderPatientInfo.phone }}</div>
          </div>
          <div class="line">
            <div>门诊：{{ chargeMsg.outpatientNumber }} 次</div>
            <div>付费：{{ chargeMsg.chargeNumber }} 次</div>
            <div>累计消费：￥{{ chargeMsg.price }}</div>
            <div>最近就诊：{{ chargeMsg.outpatientValue }}</div>
          </div>
          <el-tag effect="dark" v-for="tag in labelTags" :key="tag.value">{{ tag.label }}</el-tag>
          <el-tag effect="dark" v-for="tag in postTags" :key="tag.value">{{ tag.label }}</el-tag>
          <el-button type="primary" @click="tagVisible = true" icon="el-icon-edit" plain>{{ btnTitle }}</el-button>
          <el-button type="primary" @click="followUpPlus" v-show="deptId" icon="el-icon-plus"
            v-if="userInfo.type == 0 || userInfo.type == 1" plain>添加随访</el-button>
        </div>
      </div>
      <!-- 患者基础信息 -->
      <div class="basemsg">
        <div class="title p10">基础信息</div>
        <div class="content p10">
          <div class="line">
            <div class="display-f align-i-c">
              姓名：
              <span style="margin-right: 5px;">{{orderPatientInfo.patientName}}</span>
              <img v-if="orderPatientInfo.sysMember && orderPatientInfo.sysMember.openId" :src="imgArr.weixin" width="18"
                height="18">
            </div>
            <div>性 别：{{ orderPatientInfo.sex == '0' ? '男' : '女' }}</div>
            <div>生 日：{{ orderPatientInfo.birthday }}</div>
          </div>
          <div class="line">
            <div>年 龄：{{ orderPatientInfo.year }}岁<span
                v-show="orderPatientInfo.year < 10 && orderPatientInfo.month > 0">{{orderPatientInfo.month}}月</span>
            </div>
            <div>手机号：{{ orderPatientInfo.phone }}</div>
            <div>微信号：{{ orderPatientInfo.wxName || '-' }}</div>
          </div>
          <div class="line">
            <div>身份证号：{{ orderPatientInfo.idCard ? orderPatientInfo.idCard.slice(0, 6) + '********' + orderPatientInfo.idCard.slice(-4) : '' }}</div>
            <div>医保卡号：{{ orderPatientInfo.medicalInsurance || '-' }}</div>
            <div>居住地址：{{ orderPatientInfo.address || '-' }}</div>
          </div>
          <div class="line">
            <div>客户来源：{{ orderPatientInfo.source }}</div>
            <div>创建日期：{{ orderPatientInfo.createDate }}</div>
            <div>既往病史：{{ orderPatientInfo.previousHistory || '-' }}</div>
          </div>
        </div>
      </div>
      <!-- 患者治疗记录 -->
      <div class="record">
        <el-menu :default-active="activeIndex" class="menutitle" mode="horizontal" @select="handleSelect">
          <el-menu-item v-for="item in menuList" :key="item.index" :index="item.index">{{item.label}}</el-menu-item>
        </el-menu>
        <div class="content">
          <!-- 门诊记录 -->
          <div v-show="showIndex == '1'">
            <el-table :data="outpatientList" :max-height="500" border>
              <el-table-column type="index" label="序号" width="50" />
              <el-table-column prop="doctorName" label="就诊医生" width="120" />
              <el-table-column prop="deptName" label="就诊医馆" width="120" />
              <el-table-column prop="status" label="就诊状态" width="120" />
              <el-table-column prop="diagnosis" label="诊断结果" />
              <el-table-column prop="date" label="更新时间" width="200" />
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button icon="el-icon-view" @click="showDiagnosis(scope.row)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 收费记录 -->
          <div v-show="showIndex == '2'">
            <el-table :data="chargeList" :max-height="500" border>
              <el-table-column type="index" label="序号" width="50" />
              <el-table-column prop="deptName" label="收费医馆" />
              <el-table-column prop="typeStr" label="收费类型" />
              <el-table-column prop="status" label="订单状态" />
              <el-table-column prop="price" label="实收金额" />
              <el-table-column prop="date" label="支付时间" min-width="160" />
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button @click="showPricing(scope.row.paymentId, scope.row.type)"
                    icon="el-icon-view">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 预约记录 -->
          <div v-show="showIndex == '3'">
            <el-table :data="reservationList" :max-height="500" border>
              <el-table-column type="index" label="序号" width="50" />
              <el-table-column prop="doctorName" label="预约医生" />
              <el-table-column prop="seeDoctorDate" label="预约时间" />
              <el-table-column prop="deptName" label="预约医馆" />
              <el-table-column prop="status" label="就诊状态" />
              <el-table-column prop="operationTime" label="操作时间" min-width="160" />
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button icon="el-icon-view" @click="showSubscribe(scope.row.orderId)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 理疗记录 -->
          <div v-show="showIndex == '4'">
            <el-table :data="executeList" :max-height="500" border>
              <el-table-column type="index" label="序号" width="50" />
              <el-table-column prop="deptName" label="医馆" />
              <el-table-column prop="project" label="理疗项目" />
              <el-table-column prop="paymentStatusStr" label="订单状态" />
              <el-table-column prop="number" label="已执行/总次数" min-width="100" />
              <el-table-column prop="status" label="理疗状态" />
              <el-table-column prop="date" label="开单日期" min-width="160" />
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button icon="el-icon-view" @click="showList(scope.row)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
      <!-- 编辑患者标签 -->
      <el-dialog title="编辑标签" :visible.sync="tagVisible" width="460px" :before-close="$handleClose">
        <div class="line">
          <div>就诊科室</div>
          <div>
            <el-select v-model="posts" multiple placehageer="请选择就诊科室">
              <el-option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>
        <div class="line">
          <div>运营标签</div>
          <div>
            <el-select v-model="labels" multiple placeholder="请选择运营标签">
              <el-option v-for="item in labelOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="saveEdit">保存编辑</el-button>
          <el-button @click="tagVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 预约记录详情 -->
      <el-dialog class="editmsg" title="预约记录详情" :visible.sync="subscribeVisible" width="720px"
        :before-close="$handleClose">
        <el-form :model="subscribe" label-width="80px" inline>
          <el-form-item label="患者姓名">
            <div>{{subscribe.patientName}}</div>
          </el-form-item>
          <el-form-item label="预约渠道">
            <div>{{subscribe.channel}}</div>
          </el-form-item>
          <el-form-item label="预约医生">
            <div>{{subscribe.doctorName}}</div>
          </el-form-item>
          <el-form-item label="预约医馆">
            <div>{{subscribe.deptName}}</div>
          </el-form-item>
          <el-form-item label="就诊时间">
            <div>
              {{subscribe.schedulingTime}} {{subscribe.timeName}}
              {{subscribe.startTime | $computeTime}}-{{subscribe.stopTime | $computeTime}}
            </div>
          </el-form-item>
          <el-form-item label="就诊序号">
            <div>{{subscribe.registeredCode}} 号</div>
          </el-form-item>
          <el-form-item label="门诊类型">
            <div>{{subscribe.type}}</div>
          </el-form-item>
          <el-form-item label="就诊诊室">
            <div>{{subscribe.clinicName}}</div>
          </el-form-item>
          <el-form-item label="应付金额">
            <div>{{subscribe.copeWithPay}} 元</div>
          </el-form-item>
          <el-form-item label="实付金额">
            <div>{{subscribe.realPay}} 元</div>
          </el-form-item>
          <el-form-item label="支付方式">
            <div>{{subscribe.payWay}}</div>
          </el-form-item>
          <el-form-item label="操作人员">
            <div>{{subscribe.createBy}}</div>
          </el-form-item>
          <el-form-item label="预约时间">
            <div>{{subscribe.createTime}}</div>
          </el-form-item>
          <el-form-item label="是否退款">
            <div>{{subscribe.status == '-3' ? '已退款' : '未退款'}}</div>
          </el-form-item>
          <el-form-item v-if="subscribe.status == '-3'" label="退款人员">
            <div>{{subscribe.refundBy}}</div>
          </el-form-item>
          <el-form-item v-if="subscribe.status == '-3'" label="退款金额">
            <div>{{subscribe.refundPrice}} 元</div>
          </el-form-item>
          <el-form-item v-if="subscribe.status == '-3'" label="退款时间">
            <div>{{subscribe.refundTime}}</div>
          </el-form-item>
          <el-form-item v-if="subscribe.status == '-3'" label="退款方式">
            <div>{{subscribe.refundWay}}</div>
          </el-form-item>
          <el-form-item label="医馆电话" class="w645">
            <div>{{subscribe.phone}}</div>
          </el-form-item>
          <el-form-item label="医馆地址" class="w645">
            <div class="address">{{subscribe.deptAddress}}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="subscribeVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 理疗执行记录 -->
      <el-dialog title="理疗执行记录" :visible.sync="physioVisible" width="720px" :before-close="$handleClose">
        <el-table :data="physioDetails" :max-height="500" border>
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column prop="executionMethod" label="理疗项目" width="100" />
          <el-table-column prop="executionBy" label="执行人" width="100" />
          <el-table-column prop="createTime" label="执行时间" />
          <el-table-column prop="number" label="次数" width="100" />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button icon="el-icon-view"
                @click="showEdit(scope.row.orderOrderPaymentRecipePhysioExecutionId)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="physioVisible = false">关闭</el-button>
        </span>
        <!-- 理疗执行详情 -->
        <el-dialog class="editmsg" title="理疗执行详情" :visible.sync="executeVisible" width="720px" append-to-body
          :before-close="$handleClose">
          <el-form :model="executeForm" label-width="80px" inline>
            <el-form-item label="执行人员">
              <div>{{executeForm.executionBy}}</div>
            </el-form-item>
            <el-form-item label="治疗项目">
              <div>{{executeForm.executionMethod}}</div>
            </el-form-item>
            <el-form-item label="目前症状">
              <div>{{executeForm.symptoms || '-'}}</div>
            </el-form-item>
            <el-form-item label="治疗部位">
              <div>{{executeForm.place || '-'}}</div>
            </el-form-item>
            <el-form-item label="治疗反应">
              <div>{{executeForm.reaction || '-'}}</div>
            </el-form-item>
            <el-form-item label="治疗时长">
              <div>{{executeForm.duration + '分钟'}}</div>
            </el-form-item>
            <el-form-item label="执行情况">
              <div>{{executenum}}</div>
            </el-form-item>
            <el-form-item label="执行次数">
              <div>{{executeForm.number}}</div>
            </el-form-item>
            <el-form-item label="注意事项">
              <div>{{executeForm.attention || '-'}}</div>
            </el-form-item>
            <el-form-item label="操作时间">
              <div>{{executeForm.createTime}}</div>
            </el-form-item>
            <el-form-item label="医师备注" class="w642">
              <div class="w550">{{executeForm.remark || '-'}}</div>
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="executeVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
      </el-dialog>

    </div>
  </Card>
</template>

<script lang="js">
import getPatientDetails from "@/utils/getPatientDetails"; // 获取用户信息
import { physioExecuteList, physioExecuteInfo } from '@/api/physioexecute'; // 理疗执行记录请求
import { execute, charge, outpatient, reservation } from "@/api/patient"; // 患者诊疗记录请求
import { registeredInfo } from "@/api/registration"; // 挂号请求
import { followUpAdd } from "@/api/followup"; // 获取随访请求
import { imgArr } from "@/assets/images/img";
export default {
  name: "Details",
  data() {
    return {
      imgArr: imgArr,
      loading: true,
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      chargeMsg: {}, // 患者交易信息
      orderPatientInfo: {}, // 患者基础信息
      patientId: this.$route.query.patientId, // 患者id
      tagVisible: false,  // 编辑标签的弹框
      physioVisible: false, // 理疗执行记录弹框
      btnTitle: "添加标签", // 按钮名称
      postOptions: [], // 就诊科室列表
      labelOptions: [], // 运营标签列表
      postTags: [], // 就诊科室渲染数组
      posts: [], // 就诊科室Id数组
      labelTags: [], // 运营标签标签渲染数组
      labels: [], // 运营标签标签Id数组
      physioDetails: [], // 理疗执行记录
      menuList: [
        { label: "门诊记录", index: '1' },
        { label: "收费记录", index: '2' },
        { label: "预约记录", index: '3' },
        { label: "理疗记录", index: '4' }
      ], // 记录渲染菜单
      activeIndex: this.$session.get('showIndex') || '1', // 默认显示的记录
      showIndex: this.$session.get('showIndex') || '1', // 显示记录标记
      outpatientList: [], // 门诊记录
      chargeList: [], // 收费记录
      reservationList: [], // 预约记录
      executeList: [], // 理疗记录
      executeVisible: false, // 理疗执行详情模态框
      executeForm: {}, // 理疗执行详情对象
      executenum: null,
      subscribeVisible: false, // 预约记录详情模态框
      subscribe: {}, // 预约记录对象 
      deptId: this.$session.get('deptId'), // 医馆id
      userInfo: this.$session.get('user'), // 用户信息
      doctorInfo: this.$session.get('user').hospDoctorInfo, // 医生信息
    };
  },
  created() {
    this.getChargeMsg(); // 请求交易信息
    this.getPatientMsg('patientedit'); // 请求基础信息
    this.getPostList(); // 请求科室列表
    this.getLabelList(); // 请求标签列表
    this.getRecord(this.showIndex); // 获取记录
  },
  methods: {
    getChargeMsg: getPatientDetails.getChargeMsg, // 获取患者交易信息
    getPatientMsg: getPatientDetails.getPatientMsg, // 获取患者基础信息
    getPostList: getPatientDetails.getPostList, // 获取科室列表
    getLabelList: getPatientDetails.getLabelList, // 获取标签列表
    saveEdit: getPatientDetails.saveEdit, // 保存标签新增或编辑
    // 添加随访计划
    async followUpPlus() {
      // 判断预计随访人员
      let examPlanName = null;
      if (this.userInfo.type == '0' && this.doctorInfo.assistantName) examPlanName = this.doctorInfo.assistantName;
      else examPlanName = this.userInfo.nickName;
      // 处理随访计划参数
      let params = { 
        patientName: this.orderPatientInfo.patientName, patientId: this.patientId,
        examPlanName: examPlanName, status: 0, deptId: this.deptId, doctorId: this.doctorInfo.doctorId,
      }
      let {code} = await followUpAdd(params);
      if (code == 200) this.$message.success('设置随访计划成功！');
    },
    // 获取门诊记录
    async getOutpatient() {
      let { rows, total, code } = await outpatient({ pageSize: this.pageSize, pageNum: this.currentPage, patientId: this.patientId });
      if (code == 200) {
        if (total > 0) this.switchCase(rows);
        this.outpatientList = rows;
        this.total = total;
      }
    },
    // 获取收费记录
    async getCharge() {
      let { rows, total, code } = await charge({ pageSize: this.pageSize, pageNum: this.currentPage, patientId: this.patientId });
      if (code == 200) {
        if (total > 0) rows.forEach(item => { 
          item.price == null ? item.price = '0元' : item.price = item.price + ' 元';
          item.date == null ? item.date = '-' : item.date = item.date;
          switch (item.type) {
            case '0': item.typeStr = '中药处方订单'; break;
            case '1': item.typeStr = '理疗处方订单'; break;
            case '2': item.typeStr = '预约挂号订单'; break;
            case '3': item.typeStr = '隐秘处方订单'; break;
          }
        });
        this.chargeList = rows;
        this.total = total;
      }
    },
    // 获取预约记录
    async getReservation() {
      let { rows, total, code } = await reservation({ pageSize: this.pageSize, pageNum: this.currentPage, patientId: this.patientId });
      if (code == 200) {
        if (total > 0) this.switchCase(rows);
        this.reservationList = rows;
        this.total = total;
      }
    },
    // 处理状态
    switchCase(rows) {
      rows.forEach(item => {
        switch (item.status) {
          case '0': item.status = "待支付"; break;
          case '1': item.status = ""; break;
          case '2': item.status = "待就诊"; break;
          case '3': item.status = "已就诊"; break;
          case '4': item.status = "已划价"; break;
          case '-1': item.status = "已取消挂号"; break;
          case '-2': item.status = "停诊"; break;
          case '-3': item.status = "已退号退款"; break;
          case '-4': item.status = "已跑单"; break;
          case '-5': item.status = "支付超时"; break;
        }
      });
    },
    // 获取理疗记录
    async getExecute() {
      let { rows, total, code } = await execute({ pageSize: this.pageSize, pageNum: this.currentPage, patientId: this.patientId });
      if (code == 200) {
        rows.forEach(item => {
          switch (item.paymentStatus) {
            case '-4': item.paymentStatusStr = '已跑单'; break;
            case '-2': item.paymentStatusStr = '已退款'; break;
            case '-1': item.paymentStatusStr = '已取消'; break;
            case '0': item.paymentStatusStr = '待支付'; break;
            case '1': item.paymentStatusStr = '未完成'; break;
            case '2': item.paymentStatusStr = '已完成'; break;
          }
        });
        this.executeList = rows;
        this.total = total;
      }
    },
    // 显示理疗执行列表
    showList(obj) {
      this.orderPaymentRecipePhysioItemId = obj.orderPaymentRecipePhysioItemId;
      this.executenum = obj.number;
      this.getExecuteList();
    },
    // 获取理疗执行记录列表
    async getExecuteList() {
      let {code, rows} = await physioExecuteList({orderPaymentRecipePhysioItemId: this.orderPaymentRecipePhysioItemId});
      if (code == 200) this.physioDetails = rows;
      this.physioVisible = true;
    },
    // 获取理疗执行详情
    async showEdit(id) {
      let {code, data} = await physioExecuteInfo(id);
      if (code == 200) this.executeForm = data;
      for (let key in data) {
          if (data[key] == null) data[key] = '-';
        }
      this.executeVisible = true;
    },
    // 当前页改变
    handleCurrentChange(page) {
      this.currentPage = page;
      if (this.showIndex == '1') this.getOutpatient();
      else if (this.showIndex == '2') this.getCharge();
      else if (this.showIndex == '3') this.getReservation();
      else this.getExecute();
    },
    // 切换记录板块
    handleSelect(key){
      this.showIndex = String(key);
      this.$session.set('showIndex', this.showIndex);
      this.getRecord(this.showIndex);
    },
    // 获取记录
    getRecord(index) {
      if (index == 1) this.getOutpatient(); // 请求门诊记录
      else if (index == 2) this.getCharge(); // 请求收费记录
      else if (index == 3) this.getReservation(); // 请求预约记录
      else if (index == 4) this.getExecute(); // 请求理疗记录
    },
    // 查看门诊详情
    showDiagnosis(obj) {
      this.$session.set("href", location.pathname + location.search);
      this.$router.push("/doctorworkstation/diagnosis?orderId=" + obj.orderId + "&patientId=" + obj.patientId + '&doctorId=' + obj.doctorId + "&flag=true&page=edit");
    },
    // 查看划价单详情
    async showPricing(paymentId, type) {
      this.$session.set("href", location.pathname + location.search);
      switch (type) {
        case '0':
          this.$router.push(`/pricing/orderdetails?paymentId=${paymentId}&type=中药处方划价单`);
          break;
        case '1':
          this.$router.push(`/pricing/orderdetails?paymentId=${paymentId}&type=理疗处方划价单`);
          break;
        case '2':
          this.showSubscribe(paymentId);
          break;
        case '3':
          this.$router.push(`/pricing/orderdetails?paymentId=${paymentId}&type=隐秘处方划价单`);
          break;
      }
    },
    // 查看预约挂号详情
    async showSubscribe(orderId) {
      let {code, data} = await registeredInfo(orderId);
      if (code == 200) {
        this.subscribeVisible = true;
        switch (data.type) {
          case '0': data.type = '普通门诊'; break;
          case '1': data.type = '普通门诊加号'; break;
          case '2': data.type = '特约门诊'; break;
          case '3': data.type = '特约门诊加号'; break;
          case '4': data.type = '理疗门诊'; break;
          case '5': data.type = '义诊'; break;
        }
        for (let key in data) {
          if (data[key] != null && typeof data[key] != 'object') this.subscribe[key] = data[key];
        }
        let obj = {
          patientName: data.hospPatientInfo.patientName, schedulingTime: data.schedulingItem.schedulingTime,
          status: data.orderInfo.status, deptAddress: data.sysDept.deptAddress, deptName: data.sysDept.deptName,
          phone: data.sysDept.phone, clinicName: data.schedulingItem.clinicName, doctorName: data.orderInfo.doctorName,
          startTime: data.schedulingTimeInfo.startTime, stopTime: data.schedulingTimeInfo.stopTime,
          timeName: data.schedulingTimeInfo.timeName
        }
        this.subscribe = {...this.subscribe, ...obj}
      }
    }
  },
};
</script>

<style lang="less" scoped>
.el-card {
  /deep/.el-card__body {
    padding-bottom: 50px;
    overflow-y: scroll;
    .patientwrap {
      & > div:not(:last-child) {
        border: 1px solid #ccc;
      }
      & > div:not(:last-child) {
        margin-bottom: 10px;
      }
      .title {
        border-bottom: 1px solid #e6e6e6;
        padding: 5px 10px;
        line-height: 30px;
      }
      .el-row {
        margin: 10px 0;
      }
      .menutitle {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #e6e6e6;
        li{
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
        }
      }
      .address {
        width: 540px;
        overflow: hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        -o-text-overflow:ellipsis;
      }
      .line {
        display: flex;
        line-height: 30px;
        margin-bottom: 5px;
        div {
          min-width: 200px;
        }
      }
      /* 患者标签 */
      .el-tag {
        margin-right: 10px;
        height: 30px !important;
        line-height: 28px !important;
      }
    }
  }
}
</style>